import React, { FunctionComponent, useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store";
import { Language } from "../../models/Translation";
import { thunkFetchLanguages } from "../../store/languages/actions";
import { asList } from "../../hooks/useLoadIfEmpty";

interface LanguageSelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value: Language) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: string;
  error?: boolean;
}

export const LanguageSelect: FunctionComponent<LanguageSelectProps> = ({
  label = "language",
  onSelected,
  onChange,
  variant = "standard",
  value = [],
  error = false,
  ...props
}) => {
  const dispatch = useDispatch();
  const languages = asList<Language>(
    useSelector<AppState, unknown>(s => s.languages)
  );
  const [state, setState] = useState<ReadonlyArray<Language>>([]);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    if (onSelected) {
      let language = state.find(language => language.id === event.target.value);

      if (language) {
        onSelected(language);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    // load if not loaded
    if (!languages || !languages.length) {
      dispatch(thunkFetchLanguages());
    }
  }, []);

  useEffect(() => {
    return setState([...languages].sort((a, b) => (a.name > b.name ? 1 : -1)));
  }, [languages]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="cluster-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="language-select-label"
        id="language-select"
        autoWidth={true}
      >
        {state &&
          state.length > 0 &&
          state.map(language => (
            <MenuItem key={language.id} value={language.id}>
              {language.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
